// @flow
import * as React from 'react';

import ResolvedClientIdContext, {
    type ResolvedClientIdContextValue
} from './ResolvedClientIdContext';

import invariant from 'invariant';

const useResolvedClientId = (): ResolvedClientIdContextValue => {
    const value = React.useContext(ResolvedClientIdContext);
    invariant(
        value,
        'Missing value, make sure ResolvedClientIdProvider present'
    );
    return value;
};

export default useResolvedClientId;
